import React from "react";

function Loader () {
    return(
        <div className="flex justify-center items-cetner m-10 py-3">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#f05b53]-700"/>
        </div>
    );
}

export default Loader;